export default "__VITE_ASSET__fsmbyjS1__"